import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Users } from "lucide-react";
import { api } from "@/lib/api";
import { Empty, GenderToggle } from "@/components/Empty";
import { BottomTab } from "@/components/BottomTab";

export default function Iscritti() {
  const nav = useNavigate();
  const [gender, setGender] = useState("Men");
  const [athletes, setAthletes] = useState([]);

  useEffect(() => {
    api.get(`/athletes?gender=${gender}`).then((r) => setAthletes(r.data)).catch(() => {});
  }, [gender]);

  const groups = gender === "Women"
    ? [["*", "ATLETE", "bg-black"]]
    : [["Red", "RED", "bg-mberror"], ["Black", "BLACK", "bg-black"]];

  return (
    <div className="min-h-screen pb-24 bg-surface" data-testid="iscritti-page">
      <header className="bg-black px-4 pb-4" style={{ paddingTop: "calc(var(--safe-top) + 16px)" }}>
        <div className="flex items-center justify-between">
          <button data-testid="iscritti-back-btn" onClick={() => nav("/event")} className="text-white">
            <ChevronLeft size={32} strokeWidth={2.5} />
          </button>
          <h1 className="text-2xl font-black text-white">Iscritti</h1>
          <div className="w-8" />
        </div>
        <div className="mt-4"><GenderToggle value={gender} onChange={setGender} /></div>
      </header>

      <div className="px-4 pt-4">
        {athletes.length === 0 ? (
          <Empty icon={<Users size={54} />} title="Nessun atleta iscritto" subtitle="Torna il giorno della gara" />
        ) : (
          groups.map(([div, label, bg]) => {
            const rows = div === "*" ? athletes : athletes.filter((a) => a.division === div);
            if (rows.length === 0) return null;
            return (
              <div key={div} className="mt-4">
                <div className={`rounded-2xl px-5 py-3 flex items-center justify-between text-white ${bg}`}>
                  <span className="text-xl font-black tracking-[0.15em]">{label}</span>
                  <span className="text-sm font-bold opacity-90">{rows.length} atleti</span>
                </div>
                <div className="bg-surface2 rounded-2xl mt-2 overflow-hidden">
                  {rows.map((a, i) => (
                    <div key={a.id} data-testid={`iscritto-${a.id}`} className={`flex items-center gap-3 px-4 py-3 ${i < rows.length - 1 ? "border-b border-surface3" : ""}`}>
                      <span className="text-brand font-black shrink-0">▸</span>
                      <div className="flex-1 min-w-0">
                        <p className="font-black text-onsurface leading-tight break-words">{a.name}</p>
                        {a.instagram && <p className="text-[13px] text-onsurface3">@{a.instagram}</p>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })
        )}
      </div>

      <BottomTab />
    </div>
  );
}
